import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackStartReturnRequestParameters extends TrackEventBaseParameters {}

const trackStartReturnRequest = (
    parameters: TrackStartReturnRequestParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "start_return_request", ...parameters }, options);
};

export default trackStartReturnRequest;
